// 9fbef606107a605d69c0edbcd8029e5d
const LOYALTY_CONSTANTS = {
  GET_LOYALTY_DETAIL: 'GET_LOYALTY_DETAIL',
  UPDATE_POINTS_IN_CART: 'UPDATE_POINTS_IN_CART',
  UPDATE_LOYALTY_POINTS: 'UPDATE_LOYALTY_POINTS',
  SIMULATE_LOYALTY_DETAIL: 'SIMULATE_LOYALTY_DETAIL',
  ADDED_TO_BAG: 'AddedToBag',
};

export default LOYALTY_CONSTANTS;
